import { useEffect } from 'react'

import { useIntercom } from 'react-use-intercom'

import CloseIcon from '@/assets/icons/icon-close.svg'
import SummerDealUmbrella from '@/assets/images/summer-deal-large.png'
import { Dialog } from '@/components/ui/dialog.tsx'
import { classNames } from '@/utils/helpers'

interface Props {
  show: boolean
  onClose: () => void
}

export const SummerDealDialog = ({ show, onClose }: Props) => {
  const intercom = useIntercom()

  useEffect(() => {
    // Create a link element for the Google Font
    const link = document.createElement('link')

    link.href =
      'https://fonts.googleapis.com/css2?family=Poetsen+One&display=swap" rel="stylesheet'
    link.rel = 'stylesheet'

    // Append the link to the head of the document
    document.head.appendChild(link)

    // Cleanup by removing the link when the component unmounts
    return () => {
      document.head.removeChild(link)
    }
  }, [])

  const handleClickUpgrade = () => {
    onClose()
    intercom.showNewMessage('I want to upgrade my license.')
  }

  const handleClickGetLicense = () => {
    onClose()
    intercom.showNewMessage('I want to get a new license')
  }

  return (
    <Dialog
      show={show}
      bigDialog
      onClose={onClose}
      panelClassName={classNames(
        'bg-[linear-gradient(91.75deg,_#FF4006_-0.05%,_#395474_100%)] !p-[1px] max-w-[800px] !rounded-[32px] !overflow-visible',
        'max-sm:max-w-[calc(100%-32px)]',
      )}
      closeIconClassName="z-20"
      showCloseIcon={false}
    >
      <div
        className={classNames(
          'relative !rounded-[32px] bg-[#0F1F32] p-12',
          'max-sm:p-8 ',
        )}
      >
        <button
          onClick={onClose}
          className="hover absolute right-4 top-4 flex h-[40px] w-[40px] items-center justify-center rounded-full border-none bg-white/10 text-white ease-linear hover:bg-white/20"
        >
          <CloseIcon className="h-6 w-6" />
        </button>
        <div className="flex flex-col items-center justify-center gap-8">
          <h2
            className="text-center text-xl text-[#FF4006]"
            style={{
              // eslint-disable-next-line no-inline-styles/no-inline-styles
              fontFamily: 'Poetsen One, sans-serif',
            }}
          >
            End of <br />
            <span
              className={classNames(
                'relative text-[83px]',
                'max-sm:text-7xl max-sm:leading-8',
              )}
            >
              Summer
              <img
                src={SummerDealUmbrella}
                alt="Summer Deal"
                className={classNames(
                  'rotate15 animate-rotate15 absolute -top-[60px] right-[20px] w-[120px]',
                  'max-sm:-top-7 max-sm:w-[80px]',
                )}
              />{' '}
            </span>{' '}
            <br /> Offer
          </h2>
          <p
            className={classNames(
              'text-center text-[24px] font-medium text-secondary-200',
              'max-sm:text-lg',
            )}
          >
            Upgrade or purchase a new license and receive access to our limited
            offer, including a <span className="text-white">50% discount</span>{' '}
            on all plans!
          </p>
        </div>
        <div
          className={classNames(
            'mt-8 flex w-full gap-3',
            'max-sm:mt-6 max-sm:flex-col max-sm:gap-4',
          )}
        >
          <button
            onClick={handleClickUpgrade}
            className="border-1 flex flex-1 items-center justify-center rounded-md border border-white  p-1 text-base leading-7 text-white hover:bg-white/5"
          >
            Upgrade License
            <span className="ml-2 rounded-md bg-[#FF4006] p-0.5 px-1 text-xs text-white">
              50% OFF
            </span>
          </button>
          <button
            onClick={handleClickGetLicense}
            className="border-1  flex flex-1 items-center justify-center rounded-md border bg-white p-1 text-base leading-7 text-[#1C3366] ease-linear hover:bg-white/90"
          >
            New License
            <span className="ml-2 rounded-md bg-[#FF4006] p-0.5 px-1 text-xs text-white">
              50% OFF
            </span>
          </button>
        </div>
      </div>
    </Dialog>
  )
}
